import {
  IReferenceCategoryResponse,
  IReferenceResponse,
} from '@shared/interfaces';

type AllowedTypes = IReferenceResponse | IReferenceCategoryResponse;

export const notDeleted = ({ is_deleted }: AllowedTypes) => !is_deleted;
